import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { MessageCircle, Users, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import FAQSection from '../components/FAQSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CalendlySection from '../components/CalendlySection';
import TeamSection, { teamMembers } from '../components/TeamSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import { openWhatsApp } from '../mock';
import { practiceAreas } from '../practiceAreas';
import { usePageMeta } from '../hooks/usePageMeta';

const PracticeHero = ({ area }) => (
  <section className="practice-hero" id="inicio" data-testid="practice-hero">
    <div className="practice-hero-container">
      <Link to="/" className="practice-back-link" data-testid="practice-back-link">
        <ArrowLeft className="w-4 h-4" /> Volver al inicio
      </Link>
      <p className="practice-eyebrow">ÁREA DE PRÁCTICA · {area.label.toUpperCase()}</p>
      <h1 className="practice-title" data-testid="practice-title">{area.h1}</h1>
      <p className="practice-subtitle">{area.subtitle}</p>
      <p className="practice-intro" data-testid="practice-intro">{area.intro}</p>
      {area.network && (
        <p className="practice-network" data-testid="practice-network">
          <Users className="w-4 h-4" strokeWidth={2} /> {area.network}
        </p>
      )}
      <button
        type="button"
        onClick={() => openWhatsApp(area.waPhone, area.waMessage, `practice-${area.slug}`)}
        className="hero-whatsapp-cta practice-wa-cta"
        data-action="whatsapp-click"
        data-testid="practice-whatsapp-cta"
      >
        <MessageCircle className="w-6 h-6" strokeWidth={2.2} />
        <span>Consultanos por WhatsApp</span>
      </button>
    </div>
  </section>
);

export default function PracticePage({ slug: slugProp }) {
  const params = useParams();
  const area = practiceAreas[slugProp || params.slug];
  usePageMeta(area?.metaTitle, area?.metaDescription);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [area]);

  if (!area) return <Navigate to="/" replace />;

  return (
    <div className="landing-page" data-testid={`practice-page-${area.slug}`}>
      <Header phone={area.waPhone} />
      <PracticeHero area={area} />
      <TeamSection
        members={teamMembers.filter((m) => area.team.includes(m.id))}
        title="Quién te va a atender"
        subtitle={area.team.length > 1 ? 'Las profesionales que van a acompañarte en tu caso.' : 'La profesional que va a acompañarte en tu caso.'}
        sectionId="quien-te-atiende"
        variant="team-section-compact"
        testidPrefix="attend"
      />
      <FAQSection
        items={area.faqs}
        title={`Preguntas frecuentes sobre ${area.label.toLowerCase()}.`}
        subtitle="Respuestas generales. Cada caso es distinto: en la consulta analizamos el tuyo en particular."
      />
      <ContactSection defaultMotivo={area.motivo} />
      <TestimonialsSection />
      <CalendlySection />
      <Footer phone={area.waPhone} />
      <FloatingWhatsApp phone={area.waPhone} message={area.waMessage} label={`floating-${area.slug}`} />
    </div>
  );
}
